// eslint-disable-next-line
import { BasicLayout, RouteView } from '@/layout';
import permission from '@/utils/permission';
import store from '@/store/index';
export const asyncRouterMap = [];

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'Root',
    component: BasicLayout,
    redirect: store.getters.getConfig.is_header ? '/index' : '/index',
    meta: {
      title: store.getters.getConfig.www_title,
    },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index.vue'),
        meta: {
          hideMenu: true,
        },
      },
      {
        path: 'admin',
        redirect: '/admin/info',
        component: RouteView,
        meta: {},
        children: [
          {
            path: 'info',
            name: 'AdminInfo',
            component: () => import('@/views/admin/info/info.vue'),
            meta: {
              title: '个人信息',
              hideMenu: false,
            },
          },
          {
            path: 'company',
            name: 'AdminCompany',
            component: () => import('@/views/admin/info/company.vue'),
            meta: {
              title: '我的企业',
              hideMenu: false,
            },
          },
          {
            path: 'contract',
            name: 'AdminContract',
            component: () => import('@/views/admin/contract/index.vue'),
            meta: {
              title: '保函订单',
              hideMenu: false,
            },
          },
          {
            path: 'contract_detail/:id',
            name: 'AdminContractDetail',
            component: () => import('@/views/admin/contract/detail.vue'),
            meta: {
              title: '保函详情',
              hideMenu: false,
            },
          },
          {
            path: 'contract_apply',
            name: 'AdminContractApply',
            component: () => import('@/views/admin/contract/apply.vue'),
            meta: {
              title: '申请保函',
              hideMenu: false,
            },
          },
          {
            path: 'othercontract_apply/:id',
            name: 'AdminContractApply',
            component: () => import('@/views/admin/contract/otherapply.vue'),
            meta: {
              title: '申请其他保函',
              hideMenu: false,
            },
          },
        ],
      },
      {
        path: 'projects',
        name: 'Project',
        component: () => import('@/views/project/index.vue'),
        meta: {
          title: '工程项目',
          hideMenu: true,
        },
      },
      {
        path: 'contract_check',
        name: 'ContractCheck',
        component: () => import('@/views/contract/check.vue'),
        meta: {
          title: '保函查验',
          hideMenu: true,
        },
      },
      {
        path: 'zhejiang',
        name: 'Zhejiang',
        component: RouteView,
        redirect: '/zhejiang/apply',
        meta: {
          title: '浙江省资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'ZhejiangApply',
            component: () => import('@/views/ggb/zhejiang/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
  { path: '*', name: 'other', redirect: '/404', hidden: true },
  {
    path: '/delogin',
    name: 'Delogin',
    component: () => import('@/views/delogin/deindex.vue'),
  },
];

export const useRoleRouter = () => {
  return [
    {
      name: 'MyTeam',
      show: permission(['my_team'], ''),
    },
    {
      name: 'ReportLinhai',
      show: permission(['report', 'linhai'], ''),
    },
  ];
};
